export default __webpack_public_path__ + "static/media/gb.6cf90268.svg";